export default __webpack_public_path__ + "static/media/prevIcon.846ace30.svg";